import ReactDOM from 'react-dom';

import App from './App';
import './i18n';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import axios from "axios";
import config from '../src/config';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = config.API_URL;

ReactDOM.render(
    <Provider store={configureStore({})}>
        <App />
    </Provider>,
    document.getElementById('root')
);

